/* ============================================================
   DAPPER SINGH — Custom JS
   Father's Day 2026 | Mobile Conversion Optimized
   ============================================================ */

(function() {
  'use strict';

  /* ── SCROLL REVEAL ── */
  function initScrollReveal() {
    const revealEls = document.querySelectorAll(
      '.card-wrapper, .product__title, .image-with-text__content, .featured-product .product__info-container, .ds-scent-card'
    );
    revealEls.forEach((el, i) => {
      el.classList.add('ds-reveal');
      el.classList.add('ds-reveal-delay-' + ((i % 3) + 1));
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ds-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.ds-reveal').forEach(el => observer.observe(el));
  }

  /* ── STICKY MOBILE ATC ── */
  function initStickyATC() {
    if (window.innerWidth > 749) return;

    const atcBtn = document.querySelector('.product-form__submit, button[name="add"]');
    if (!atcBtn) return;

    // Create sticky bar
    const productTitle = document.querySelector('.product__title h1')?.textContent?.trim() || 'Ritual Oil';
    const productPrice = document.querySelector('.price-item--regular')?.textContent?.trim() || '';

    const stickyBar = document.createElement('div');
    stickyBar.className = 'ds-sticky-atc';
    stickyBar.innerHTML = `
      <div class="ds-sticky-product">
        <div class="ds-sticky-title">${productTitle}</div>
        <div class="ds-sticky-price">${productPrice}</div>
      </div>
      <button class="ds-sticky-btn">Add to Cart</button>
    `;
    document.body.appendChild(stickyBar);

    // Wire sticky button to actual ATC
    stickyBar.querySelector('.ds-sticky-btn').addEventListener('click', () => {
      atcBtn.click();
    });

    // Show/hide based on scroll
    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0.1 });

    atcObserver.observe(atcBtn);
  }

  /* Removed: initShippingBar. It built a "$N away from free shipping" progress
     bar against a $75 threshold that does not exist. Shipping is free on every
     order, verified against /cart/shipping_rates.json. It was also never
     visible: .cart-drawer__header does not exist in this theme so it fell back
     to prepending into a closed drawer, nothing in the theme dispatches
     cart:open or cart:updated, and Dawn's cart-drawer.js overwrites the
     drawer's innerHTML on every cart update. Replaced by a static line in
     snippets/ds-free-shipping-note.liquid. */

  /* ── PRODUCT IMAGE PARALLAX (desktop only) ── */
  function initParallax() {
    if (window.innerWidth < 750) return;

    const heroMedia = document.querySelector('.banner__media');
    if (!heroMedia) return;

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.scrollY;
          heroMedia.style.transform = `translateY(${scrolled * 0.3}px)`;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── PRODUCT IMAGE HOVER ZOOM (mobile swipe) ── */
  function initProductGallery() {
    const gallery = document.querySelector('.product__media-list');
    if (!gallery) return;

    // Touch swipe support
    let startX = 0;
    let isDragging = false;

    gallery.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        const items = gallery.querySelectorAll('.product__media-item');
        // Trigger next/prev — Shopify's slider handles this natively
        if (diff > 0) {
          document.querySelector('.slider-button--next')?.click();
        } else {
          document.querySelector('.slider-button--prev')?.click();
        }
      }
      isDragging = false;
    }, { passive: true });
  }

  /* ── GIFT BADGE ON BUNDLE PRODUCTS ── */
  function injectGiftBadge() {
    const title = document.querySelector('.product__title h1, .product__title');
    if (!title) return;

    const titleText = title.textContent.toLowerCase();
    if (titleText.includes('set') || titleText.includes('bundle') || titleText.includes('box')) {
      const badge = document.createElement('div');
      badge.className = 'ds-gift-badge';
      badge.textContent = 'Gift Ready';
      title.parentNode.insertBefore(badge, title);
    }
  }

  /* ── ANNOUNCEMENT BAR COUNTDOWN ── */
  function initCountdown() {
    const bar = document.querySelector('.announcement-bar__message, .announcement-bar a');
    if (!bar) return;

    // Father's Day: June 21, 2026
    const target = new Date('2026-06-21T00:00:00');

    function update() {
      const now = new Date();
      const diff = target - now;
      if (diff <= 0) return;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hrs = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      if (days <= 14) {
        const msg = days > 0
          ? `Father's Day is in ${days} day${days !== 1 ? 's' : ''} — Order by June 18 for guaranteed delivery`
          : `Order today for Father's Day delivery`;
        bar.textContent = msg;
      }
    }

    update();
    setInterval(update, 60000);
  }

  /* ── INIT ALL ── */
  function init() {
    initScrollReveal();
    initStickyATC();
    initParallax();
    initProductGallery();
    injectGiftBadge();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on section changes (Shopify theme editor)
  document.addEventListener('shopify:section:load', init);

})();

/* ============================================================
   PATCH 2 — Announcement Bar + Social Proof + Gift Section
   ============================================================ */

(function() {

  /* ── ANNOUNCEMENT BAR ── */
  function injectAnnouncementBar() {
    if (document.querySelector('.ds-announcement')) return;

    const target = new Date('2026-06-21T00:00:00');
    const now = new Date();
    const daysLeft = Math.floor((target - now) / (1000 * 60 * 60 * 24));

    let msg = '🚚 Free shipping on orders $75+ · ';
    if (daysLeft > 0 && daysLeft <= 14) {
      msg += `Father's Day is in ${daysLeft} day${daysLeft !== 1 ? 's' : ''} — Order by June 18`;
    } else {
      msg += 'Order today · Arrives gift-ready';
    }

    const bar = document.createElement('div');
    bar.className = 'ds-announcement';
    bar.innerHTML = msg;

    // Insert at very top of body, before everything
    const header = document.querySelector('.header-wrapper, header, #shopify-section-header');
    if (header) {
      header.parentNode.insertBefore(bar, header);
    } else {
      document.body.prepend(bar);
    }
  }

  /* ── SOCIAL PROOF SECTION (disabled — using Judge.me widget) ── */
  function injectSocialProof() {
    return; // Judge.me widget handles this now
    if (document.querySelector('.ds-social-proof')) return;
    if (window.location.pathname !== '/') return;

    var section = document.createElement('div');
    section.className = 'ds-social-proof';
    section.innerHTML = [
      '<div class="ds-social-proof__stars">★★★★★</div>',
      '<div class="ds-social-proof__rating">4.9</div>',
      '<div class="ds-social-proof__count">Verified Customers</div>',
      '<div class="ds-testimonials" id="ds-testimonials-grid">',
        '<div class="ds-testimonial">',
          '<div class="ds-testimonial__text">My morning routine is completely different now. Three drops and I\'m ready. It\'s the one thing I don\'t skip.</div>',
          '<div class="ds-testimonial__name">Minoo</div>',
          '<div class="ds-testimonial__scent">Sol Ritual Oil</div>',
        '</div>',
        '<div class="ds-testimonial">',
          '<div class="ds-testimonial__text">Bought this as a Father\'s Day gift and my husband immediately asked where I found it. The scent is unlike anything else.</div>',
          '<div class="ds-testimonial__name">Tiffany</div>',
          '<div class="ds-testimonial__scent">Sol Grooming Set</div>',
        '</div>',
        '<div class="ds-testimonial">',
          '<div class="ds-testimonial__text">Black Temple is exactly what it sounds like — deep, grounded, and commanding. Worth every penny.</div>',
          '<div class="ds-testimonial__name">Harry</div>',
          '<div class="ds-testimonial__scent">Black Temple Ritual Oil</div>',
        '</div>',
      '</div>'
    ].join('');

    var main = document.querySelector('main, .content-for-layout');
    var hero = document.querySelector('.shopify-section:first-of-type');
    if (hero) {
      hero.insertAdjacentElement('afterend', section);
    } else if (main) {
      main.prepend(section);
    }

    // Try to pull real Judge.me reviews via their public widget API
    loadJudgeMeReviews(section.querySelector('#ds-testimonials-grid'));
  }

  function loadJudgeMeReviews(container) {
    var shop = 't5gsd1-vv.myshopify.com';
    var token = 'M9BMSD5q5ufgfjDwMXoyh-SKWBs';
    fetch('https://judge.me/api/v1/reviews?api_token=' + token + '&shop_domain=' + shop + '&per_page=3&rating=5')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.reviews || data.reviews.length === 0) return;
        container.innerHTML = data.reviews.map(function(r) {
          return [
            '<div class="ds-testimonial">',
              '<div class="ds-testimonial__text">' + r.body.replace(/</g,'&lt;').substring(0, 200) + '</div>',
              '<div class="ds-testimonial__name">' + (r.reviewer && r.reviewer.name ? r.reviewer.name.split(' ')[0] : 'Verified') + '</div>',
              '<div class="ds-testimonial__scent">Verified Purchase</div>',
            '</div>'
          ].join('');
        }).join('');
      })
      .catch(function() { /* keep hardcoded fallback */ });
  }

  /* ── GIFT SETS SECTION ── */
  function injectGiftSection() {
    if (document.querySelector('.ds-gift-section')) return;
    if (window.location.pathname !== '/') return;

    const section = document.createElement('div');
    section.className = 'ds-gift-section ds-reveal';
    section.innerHTML = `
      <div class="ds-gift-section__eyebrow">Father's Day · June 21</div>
      <h2 class="ds-gift-section__heading">Give him the ritual.</h2>
      <p class="ds-gift-section__sub">Comes gift-ready. No wrapping needed. Free shipping on orders $75+.</p>
      <div class="ds-gift-cards">
        <a href="/products/dapper-singh-ritual-oil-and-beard-brush-kit-bundle" class="ds-gift-card ds-gift-card--has-img">
          <img src="https://cdn.shopify.com/s/files/1/0976/0646/7716/files/cbf68cb0d85749759f4ca4a100f5c962.webp?v=1771449407" alt="Ritual Grooming Set" class="ds-gift-card__img" loading="lazy">
          <div class="ds-gift-card__content">
            <div class="ds-gift-card__badge">Best Seller · Father's Day</div>
            <div class="ds-gift-card__name">Ritual Grooming Set</div>
            <div class="ds-gift-card__desc">Ritual oil · Boar bristle brush · Styling brush · Brush rake · Leather pouch · Magnetic gift box</div>
            <div class="ds-gift-card__price">$99 <span style="color:var(--ds-muted);font-size:11px;text-decoration:line-through;margin-left:6px;">$154 value</span></div>
            <span class="ds-gift-card__arrow">Shop Now →</span>
          </div>
        </a>
        <a href="/products/valentines-day-luxury-box" class="ds-gift-card ds-gift-card--has-img">
          <img src="https://cdn.shopify.com/s/files/1/0976/0646/7716/files/Placed_Items_Lux_Box_Product.jpg?v=1776650718" alt="Limited Release Luxury Box" class="ds-gift-card__img" loading="lazy">
          <div class="ds-gift-card__content">
            <div class="ds-gift-card__badge">Limited Release</div>
            <div class="ds-gift-card__name">Luxury Box</div>
            <div class="ds-gift-card__desc">Ritual oil · Silk scarf · Silk eye mask · Obsidian gua sha · Ritual matches · Leather bookmark · Wax seal box</div>
            <div class="ds-gift-card__price">$180</div>
            <span class="ds-gift-card__arrow">Shop Now →</span>
          </div>
        </a>
      </div>
      <a href="/collections/all" class="ds-gift-section__cta">Shop All Gifts</a>
    `;

    // Insert after social proof or after second featured product
    const socialProof = document.querySelector('.ds-social-proof');
    const secondFeatured = document.querySelectorAll('.section-featured-product')[1];
    const insertAfter = socialProof || secondFeatured;

    if (insertAfter) {
      insertAfter.insertAdjacentElement('afterend', section);
    } else {
      const main = document.querySelector('main, .content-for-layout');
      if (main) main.appendChild(section);
    }

    // Scroll reveal
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('ds-visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    obs.observe(section);
  }

  /* ── INIT ── */
  function initPatch2() {
    // injectAnnouncementBar(); // Disabled — Summer of Sol has its own announcement bar
    injectSocialProof();
    // injectGiftSection(); // Disabled — Father's Day is over
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPatch2);
  } else {
    initPatch2();
  }

  document.addEventListener('shopify:section:load', initPatch2);

})();

/* ============================================================
   PATCH 3 — Father's Day Landing Page
   ============================================================ */

(function() {

  var IS_HOME = window.location.pathname === '/';

  /* ── FATHER'S DAY URGENCY BANNER (replaces generic bar) ── */
  function injectFDUrgencyBanner() {
    if (document.querySelector('.ds-fd-urgency')) return;

    var target = new Date('2026-06-21T00:00:00');
    var now = new Date();
    var daysLeft = Math.floor((target - now) / (1000 * 60 * 60 * 24));

    if (daysLeft <= 0 || daysLeft > 30) return;

    var bar = document.createElement('div');
    bar.className = 'ds-fd-urgency';

    var urgencyText = daysLeft <= 7
      ? 'Last chance — only ' + daysLeft + ' day' + (daysLeft !== 1 ? 's' : '') + ' until Father\'s Day. Order by June 18 for delivery.'
      : 'Father\'s Day is June 21 — ' + daysLeft + ' days away. Free shipping on orders $75+.';

    bar.innerHTML = '<span>' + urgencyText + '</span>';

    // Always prepend to body so it appears above everything including mobile header
    var existing = document.querySelector('.ds-fd-urgency, .ds-announcement');
    if (existing) {
      existing.parentNode.replaceChild(bar, existing);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  /* ── HERO FATHER'S DAY OVERLAY ── */
  function injectFDHeroOverlay() {
    if (!IS_HOME) return;
    if (document.querySelector('.ds-fd-hero-overlay')) return;

    var banner = document.querySelector('.banner, .shopify-section .banner');
    if (!banner) return;

    // Remove any existing banner box text (Shopify theme default)
    var existingBox = banner.querySelector('.banner__box');
    if (existingBox) existingBox.style.display = 'none';

    var overlay = document.createElement('div');
    overlay.className = 'ds-fd-hero-overlay';
    overlay.innerHTML = [
      '<div class="ds-fd-hero-overlay__inner">',
        '<div class="ds-fd-hero-overlay__eyebrow">Father\'s Day · June 21</div>',
        '<h1 class="ds-fd-hero-overlay__heading">Everything He Needs.<br>Nothing He\'d Buy Himself.</h1>',
        '<p class="ds-fd-hero-overlay__sub">Fragrance-forward ritual oils for beard, hair, and skin.<br>Five signature scents. Gift-ready presentation.</p>',
        '<div class="ds-fd-hero-overlay__ctas">',
          '<a href="/collections/all" class="ds-fd-hero-btn ds-fd-hero-btn--primary">Shop Father\'s Day Gifts</a>',
          '<a href="#ds-scent-guide" class="ds-fd-hero-btn ds-fd-hero-btn--ghost">Find Your Signature Scent</a>',
        '</div>',
      '</div>'
    ].join('');

    banner.style.position = 'relative';
    banner.appendChild(overlay);
  }

  /* ── GIFTING PITCH SECTION ── */
  function injectGiftingPitch() {
    if (!IS_HOME) return;
    if (document.querySelector('.ds-gifting-pitch')) return;

    var section = document.createElement('div');
    section.className = 'ds-gifting-pitch ds-reveal';
    section.innerHTML = [
      '<div class="ds-gifting-pitch__inner">',
        '<div class="ds-gifting-pitch__text">',
          '<div class="ds-gifting-pitch__eyebrow">Ritual Over Routine</div>',
          '<h2 class="ds-gifting-pitch__heading">Gifts Worth Giving.<br>Rituals Worth Keeping.</h2>',
          '<p class="ds-gifting-pitch__body">Most gifts are opened and forgotten. Dapper Singh products become part of a daily ritual. Thoughtfully crafted, beautifully presented, and made to be used long after Father\'s Day has passed.</p>',
          '<div class="ds-gifting-pitch__features">',
            '<div class="ds-gifting-pitch__feat"><span class="ds-gifting-pitch__feat-icon">✦</span>Five signature scents</div>',
            '<div class="ds-gifting-pitch__feat"><span class="ds-gifting-pitch__feat-icon">✦</span>Gift-ready presentation</div>',
            '<div class="ds-gifting-pitch__feat"><span class="ds-gifting-pitch__feat-icon">✦</span>Free shipping on orders $75+</div>',
            '<div class="ds-gifting-pitch__feat"><span class="ds-gifting-pitch__feat-icon">✦</span>Crafted in California</div>',
          '</div>',
          '<a href="/collections/all" class="ds-gifting-pitch__cta">Shop Father\'s Day Gifts</a>',
        '</div>',
        '<div class="ds-gifting-pitch__quote">',
          '<blockquote class="ds-gifting-pitch__blockquote">"Ritual starts here."</blockquote>',
          '<cite class="ds-gifting-pitch__cite">Dapper Singh</cite>',
        '</div>',
      '</div>'
    ].join('');

    // Insert after gift section or social proof
    var giftSection = document.querySelector('.ds-gift-section');
    var socialProof = document.querySelector('.ds-social-proof');
    var insertAfter = giftSection || socialProof;

    if (insertAfter) {
      insertAfter.insertAdjacentElement('afterend', section);
    } else {
      var main = document.querySelector('main, .content-for-layout');
      if (main) main.appendChild(section);
    }

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('ds-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    obs.observe(section);
  }

  /* ── FORCE JUDGE.ME STYLES — MutationObserver approach ── */
  function forceJudgeMeStyles() {
    // Inject override stylesheet last in <head> to win specificity
    if (!document.getElementById('ds-jdgm-override')) {
      var style = document.createElement('style');
      style.id = 'ds-jdgm-override';
      style.textContent = [
        '.jdgm-rev__body, .jdgm-carousel-item__body, .jdgm-rev__author, .jdgm-carousel-item__author, .jdgm-widget__heading, .jdgm-summary__count { font-family: "Montserrat", sans-serif !important; }',
        '.jdgm-widget, .jdgm-carousel { background: #0a0a0a !important; padding: 48px 20px !important; }',
        '.jdgm-widget__heading, .jdgm-carousel__title, .jdgm-summary__header { font-family: "Cormorant Garamond", serif !important; color: #ffffff !important; font-size: 2rem !important; font-weight: 300 !important; letter-spacing: 0.04em !important; }',
        '.jdgm-carousel-item, .jdgm-rev { background: #111111 !important; border: 1px solid #2a2520 !important; border-radius: 0 !important; }',
        /* Force ALL text inside widget to white */
        '.jdgm-carousel-item *, .jdgm-rev * { color: #ffffff !important; }',
        /* Then selectively re-color specific elements */
        '.jdgm-rev__rating *, .jdgm-carousel-item__rating *, .jdgm-star { color: #aa8539 !important; }',
        '.jdgm-rev__author, .jdgm-carousel-item__author { color: #c8ae6d !important; }',
        '.jdgm-rev__timestamp, .jdgm-rev__prod-title a { color: #6b6560 !important; }',
        /* Quote marks — target the icon/before element */
        '.jdgm-carousel-item__icon, .jdgm-rev__icon, [class*="jdgm"][class*="quot"], [class*="jdgm"][class*="icon"] { color: #aa8539 !important; }',
        /* Verified badge */
        '[class*="jdgm"][class*="badge"], [class*="jdgm"][class*="verified"] { color: #aa8539 !important; background: transparent !important; border-color: #aa8539 !important; }',
        /* Summary bar */
        '.jdgm-summary__rating, .jdgm-summary__stars, .jdgm-summary * { color: #ffffff !important; }',
        '.jdgm-summary__stars [class*="star"] { color: #aa8539 !important; }',
        /* Arrows */
        '.jdgm-carousel__arrow, .jdgm-carousel__arrow * { color: #aa8539 !important; border-color: #2a2520 !important; background: #111 !important; }',
      ].join('\n');
      document.head.appendChild(style);
    }

    // Direct DOM paint — run immediately and again after widget renders
    function paintJDGM() {
      document.querySelectorAll('[class*="jdgm"]').forEach(function(el) {
        var c = (el.className && el.className.toString) ? el.className.toString() : '';
        // Everything gets white text as base
        el.style.setProperty('color', '#ffffff', 'important');
        // Stars get gold
        if (c.indexOf('star') !== -1 || c.indexOf('rating') !== -1) {
          el.style.setProperty('color', '#aa8539', 'important');
        }
        // Author/name gets soft gold
        if (c.indexOf('author') !== -1 || c.indexOf('reviewer') !== -1 || c.indexOf('name') !== -1) {
          el.style.setProperty('color', '#c8ae6d', 'important');
        }
        // Teal detection — kill it
        var computed = window.getComputedStyle(el).color;
        if (computed) {
          var p = computed.match(/\d+/g);
          if (p && parseInt(p[1]) > 100 && parseInt(p[1]) > parseInt(p[0]) * 1.5) {
            el.style.setProperty('color', '#aa8539', 'important');
          }
        }
      });
    }

    paintJDGM();
    setTimeout(paintJDGM, 500);
    setTimeout(paintJDGM, 1500);
    setTimeout(initJDGMCarousel, 800);
    setTimeout(initJDGMCarousel, 2500);

    // Watch for Judge.me async rendering
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          /* Read classes via classList, not className. On an SVG element
             className is an SVGAnimatedString, so it is truthy and has no
             indexOf. That threw inside this callback and aborted the rest of
             the mutation batch, which silently stopped paintJDGM() from
             running for every node added after the first SVG. */
          if (node.nodeType === 1 && node.classList.toString().indexOf('jdgm') !== -1) {
            paintJDGM();
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ── PRODUCT CARD HOVER: packaging → bottle for 30ml oils ── */
  var CDN = 'https://cdn.shopify.com/s/files/1/0976/0646/7716/files/';
  var HOVER_IMAGES = {
    // 30ml oils — packaging → bottle
    'sol-ritual-oil-1':                    CDN + 'Core_Bottle_Hero_Image.jpg',
    'dapper-singh-black-temple-ritual-oil': CDN + '0396df9354f043b0a6dd749426c74f3a.webp',
    'bala-ritual-oil':                     CDN + 'Bala_30_ML_bottle.png',
    'ichiban-ritual-oil-copy':             CDN + 'Ichiban_30ml_bottle.png',
    'blue-note-ritual-oil':                CDN + 'Blue_Note_30ML_Ritual_Oil_Botle.png',
    // 10ml travel rituals — product shot → oil/dropper
    'sol-travel-ritual':                   CDN + 'Oil_Drop_PDP.png',
    'bala-travel-ritual':                  CDN + 'Top_of_the_oil_-_bala.png',
    'black-temple-travel-ritual':          CDN + 'topoftheoil.png',
    'blue-note-travel-ritual':             CDN + 'blue_note_dropper_marble.png',
    'ichiban-travel-ritual':               CDN + 'Ichiban_Oil_Batch.png',
    // Bundles
    'beard-brush-kit':                     CDN + 'b1a12eac4ffa4f4196240d38b2bd60af.webp',
    'dapper-singh-ritual-oil-and-beard-brush-kit-bundle': CDN + 'f156f6267d184fd2b3b1453eb3591ca3.webp',
    'valentines-day-luxury-box':           CDN + 'Placed_Items_Lux_Box_Product.jpg'
  };
  // Keep backward-compat alias
  var BOTTLE_IMAGES = HOVER_IMAGES;

  function applyHover(el, img, packagingUrl, bottleUrl) {
    // Two-image crossfade — no src swap, no flash
    var wrapper = img.parentNode;
    var wrapperPos = getComputedStyle(wrapper).position;
    if (wrapperPos === 'static') wrapper.style.position = 'relative';

    // Layer the bottle image on top, hidden by default
    var bottleImg = new Image();
    bottleImg.src = bottleUrl;
    bottleImg.alt = img.alt || '';
    bottleImg.style.cssText = [
      'position:absolute', 'inset:0', 'width:100%', 'height:100%',
      'object-fit:cover', 'object-position:center',
      'opacity:0', 'transition:opacity 0.5s ease',
      'pointer-events:none'
    ].join(';');
    wrapper.appendChild(bottleImg);

    el.addEventListener('mouseenter', function() { bottleImg.style.opacity = '1'; });
    el.addEventListener('mouseleave', function() { bottleImg.style.opacity = '0'; });
  }

  function initCardHover() {
    // Shopify product cards (.card-wrapper)
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var handle = (link.href.split('/products/')[1] || '').split('?')[0].split('#')[0];
      var bottleUrl = BOTTLE_IMAGES[handle];
      if (!bottleUrl) return;
      var img = card.querySelector('.card__media img, .media img');
      if (!img) return;
      applyHover(card, img, img.src.split('?')[0], bottleUrl);
    });
  }

  /* ── JUDGE.ME 3-UP PAGED CAROUSEL ── */
  function initJDGMCarousel() {
    var container = document.querySelector('.jdgm-testimonials-container');
    if (!container || container.dataset.dsCarousel) return;
    var items = Array.from(container.querySelectorAll('.jdgm-card.jdgm-testimonial'));
    if (items.length < 2) return;
    container.dataset.dsCarousel = '1';

    var perPage = window.innerWidth <= 749 ? 1 : 3;
    var page = 0;
    var pages = Math.ceil(items.length / perPage);

    function showPage(p) {
      page = Math.max(0, Math.min(p, pages - 1));
      items.forEach(function(item, i) {
        var visible = i >= page * perPage && i < (page + 1) * perPage;
        item.classList.toggle('ds-jdgm-hidden', !visible);
      });
    }
    showPage(0);

    // Nav below the container
    var nav = document.createElement('div');
    nav.className = 'ds-jdgm-nav';
    var prevBtn = document.createElement('button');
    prevBtn.className = 'ds-jdgm-btn';
    prevBtn.innerHTML = '&#8592;';
    var nextBtn = document.createElement('button');
    nextBtn.className = 'ds-jdgm-btn';
    nextBtn.innerHTML = '&#8594;';
    prevBtn.addEventListener('click', function() { showPage(page - 1); });
    nextBtn.addEventListener('click', function() { showPage(page + 1); });
    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);
    // Insert after the full widget section, not inside the grid
    var widgetParent = container.closest('.shopify-section, .jdgm-widget') || container.parentNode;
    widgetParent.insertAdjacentElement('afterend', nav);
  }

  /* ── INIT ── */
  function initPatch3() {
    // injectFDUrgencyBanner(); // Disabled — Father's Day is over
    // injectFDHeroOverlay(); // Disabled — Father's Day is over
    // injectGiftingPitch(); // Disabled — Father's Day is over
    // Hover swap on Shopify product cards
    initCardHover();
    forceJudgeMeStyles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPatch3);
  } else {
    initPatch3();
  }

  document.addEventListener('shopify:section:load', initPatch3);

})();

/* ── LIFESTYLE GRID SCROLL ANIMATIONS ── */
(function () {
  var parallaxItems = [];

  function initLifestyleAnimations() {
    var items = document.querySelectorAll('.ds-lifestyle-grid__item');
    if (!items.length) return;

    parallaxItems = [];

    // Fade-in on scroll into view
    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ds-anim-in');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      items.forEach(function (el) { fadeObserver.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('ds-anim-in'); });
    }

    // Parallax — collect images
    items.forEach(function (el) {
      var img = el.querySelector('.ds-img-cover');
      if (img) parallaxItems.push({ el: el, img: img });
    });

    if (parallaxItems.length) {
      onScroll();
    }
  }

  function onScroll() {
    var windowH = window.innerHeight;
    parallaxItems.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      // progress: 0 when bottom of item enters viewport, 1 when top exits
      var progress = 1 - (rect.bottom / (windowH + rect.height));
      progress = Math.max(0, Math.min(1, progress));
      // shift image -8% to +8% vertically
      var shift = (progress - 0.5) * 16;
      item.img.style.transform = 'translateY(' + shift + '%)';
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLifestyleAnimations);
  } else {
    initLifestyleAnimations();
  }

  document.addEventListener('shopify:section:load', initLifestyleAnimations);
})();
